<template>
  <v-dialog :retain-focus="false" :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>

      <v-card-text style="max-height: 70vh; overflow-y: auto">
        <div class="mb-4">
          <label class="label-input">Section</label>
          <v-row>
            <v-col cols="12" md="8">
              <v-text-field v-model="fields.title" label="Name" hide-details />
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox v-model="fields.enableAnchor" label="Enable Anchor" hide-details />
            </v-col>
          </v-row>
        </div>

        <div class="mb-4">
          <SectionSettingsContainerFuild :settings="fields.settings" :container-page="fields.containerPage" />
        </div>

        <div class="mb-4">
          <label class="label-input">Shipping Bar</label>
          <div class="group-item">
            <v-row>
              <v-col cols="12" md="6">
                <ColorPicker
                  v-model="fields.bar.background"
                  name="bar-background"
                  label="Background Color"
                  default-color="#f6f6f6"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model.number="fields.bar.borderRadius"
                  type="number"
                  label="Border Radius"
                  min="0"
                  suffix="px"
                  hide-details
                  :rules="[v => v >= 0 || 'Border Radius must be greater than or equal 0']"
                />
              </v-col>
            </v-row>
          </div>
        </div>

        <div class="mb-4">
          <label class="label-input">Ship Date (Left)</label>
          <div class="group-item">
            <v-row>
              <v-col cols="12" md="12">
                <ColorPicker
                  v-model="fields.shipping.dotColor"
                  name="dot-color"
                  label="Dot Color"
                  default-color="#22c55e"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field v-model="fields.shipping.prefixText" label="Prefix Text" hide-details />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model.number="fields.shipping.deliveryDays"
                  type="number"
                  label="Delivery Days (Current date + days)"
                  min="0"
                  hide-details
                  :rules="[v => v >= 0 || 'Delivery days must be greater than or equal 0']"
                />
              </v-col>
            </v-row>
            <p class="mt-3 mb-0 text-caption">
              Preview date: <strong>{{ previewShipDate }}</strong>
            </p>
          </div>
        </div>

        <div class="mb-4">
          <label class="label-input">Location (Right)</label>
          <div class="group-item">
            <div class="mb-4">
              <UploadImage
                @callback="handleUploadFlagImage"
                :image="{ imageSrc: fields.location.flagUrl }"
                :height="`80`"
                :typeUpload="'image'"
                @callbackDelete="handleRemoveFlagImage"
              />
            </div>
            <v-row>
              <v-col cols="12" md="4">
                <v-text-field v-model="fields.location.prefixText" label="Prefix Text" hide-details />
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field v-model="fields.location.countryCode" label="Country Code" hide-details />
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field v-model="fields.location.suffixText" label="Suffix Text" hide-details />
              </v-col>
            </v-row>
          </div>
        </div>
      </v-card-text>

      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';
import { updateHtmlFromData } from '../common/html/update.js';
import ColorPicker from './common/color-picker.vue';
import SectionSettingsContainerFuild from './common/section-settings-container-fuild.vue';

export default {
  name: 'saintbrand-shipping-section-editor',
  components: {
    ColorPicker,
    SectionSettingsContainerFuild,
    UploadImage,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      fields: {
        title: 'Saintbrand Shipping',
        enableAnchor: false,
        settings: {
          paddingTop: true,
          paddingBottom: true,
          backgroundColor: '#FFFFFF',
          textColor: '#000000',
          overlayColor: '#000000',
          overlayOpacity: 0,
          showOverlay: false,
          backgroundImage: '',
        },
        containerPage: {
          enableStyle: false,
          background: '#FFFFFF',
        },
        bar: {
          background: '#f6f6f6',
          borderRadius: 20,
        },
        shipping: {
          dotColor: '#22c55e',
          prefixText: 'Ships by ',
          deliveryDays: 14,
        },
        location: {
          flagUrl: 'https://flagcdn.com/w40/us.png',
          prefixText: 'Fast ',
          countryCode: 'US',
          suffixText: ' Shipping',
        },
      },
    };
  },
  computed: {
    previewShipDate() {
      const days = Number(this.fields.shipping.deliveryDays) || 0;
      const date = new Date();
      date.setDate(date.getDate() + days);
      return date.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
    },
  },
  mounted() {
    this.applyExtract(this.sectionEditor.sectionExtract);
  },
  watch: {
    sectionEditor: {
      handler(newVal) {
        if (newVal && newVal.sectionExtract) {
          this.applyExtract(newVal.sectionExtract);
        }
      },
      deep: true,
    },
  },
  methods: {
    applyExtract(extract) {
      if (!extract) return;
      this.fields = {
        ...this.fields,
        ...extract,
        settings: { ...this.fields.settings, ...(extract.settings || {}) },
        containerPage: { ...this.fields.containerPage, ...(extract.containerPage || {}) },
        bar: { ...this.fields.bar, ...(extract.bar || {}) },
        shipping: { ...this.fields.shipping, ...(extract.shipping || {}) },
        location: { ...this.fields.location, ...(extract.location || {}) },
      };
    },
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionSaintbrandShipping(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields.title,
        html: updateHtml,
      });
      this.$emit('close');
    },
    handleUploadFlagImage(obj) {
      if (obj && obj.imageSrc) {
        this.fields.location.flagUrl = obj.imageSrc;
      }
    },
    handleRemoveFlagImage() {
      this.fields.location.flagUrl = '';
    },
  },
};
</script>

<style lang="scss">
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
</style>
